import {eventOnFirstTime} from 'shared/helpers/analyticsHelper';
import { makeActionCreator } from 'crazyEditor/redux/helpers';
const SET_MOBILE_OPTIMIZED = 'crazyEditor/template/SET_MOBILE_OPTIMIZED';
export const SET_NOT_PREFETCHED = 'crazyEditor/template/SET_NOT_PREFETCHED';
export const UPDATE_TEMPLATE_INFO = 'crazyEditor/template/UPDATE_TEMPLATE_INFO';
export const UPDATE_CSS_URL = 'crazyEditor/template/UPDATE_CSS_URL';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case SET_MOBILE_OPTIMIZED:
      if (action.flag) {
        eventOnFirstTime('Mobile Friendly - First Turned On');
      }
      return {
        ...state,
        mobileOptimized: action.flag
      };
    case SET_NOT_PREFETCHED:
      return {
        ...state,
        prefetched: false
      };
    case UPDATE_TEMPLATE_INFO:
      return {
        ...state,
        ...action.update,
      };
    case UPDATE_CSS_URL:
      return {
        ...state,
        cssUrl: action.cssUrl,
      };
    default:
      return state;
  }
}

export const setMobileOptimized = makeActionCreator(SET_MOBILE_OPTIMIZED, 'flag');
export const updateTemplateInfo = makeActionCreator(UPDATE_TEMPLATE_INFO, 'update');
export const updateCSSUrl = makeActionCreator(UPDATE_CSS_URL, 'cssUrl');

